/**
 * Formats the surround (base) material displayName to match the PDF blueprint format.
 *
 * Asset data displayNames use a hyphen separator (e.g. "Stacked Stone - Graphite"),
 * but the PDF blueprints render base materials with a pipe separator
 * (e.g. "Stacked Stone | Graphite").
 */
export const getBaseMaterialLabel = (displayName: string | null | undefined): string => {
	if (!displayName) return 'N/A';

	return displayName.replace(/\s*-\s*/g, ' | ');
};
